export default "__VITE_ASSET__Bn3UIcnU__"